import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import gsap from "gsap";
import { HiOutlineMenu } from "react-icons/hi";
import MobileMenu from "./MobileMenu";
import { brand, nav } from "../data/siteData";
import "./Navbar.css";

export default function Navbar() {
  const navRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!navRef.current) return;
    gsap.to(navRef.current, {
      paddingTop: scrolled ? "0.7rem" : "1.4rem",
      paddingBottom: scrolled ? "0.7rem" : "1.4rem",
      duration: 0.5,
      ease: "power3.out",
    });
  }, [scrolled]);

  return (
    <>
      <header
        ref={navRef}
        className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}
      >
        <div className="navbar__inner container">
          <Link to="/" className="navbar__logo">
            {brand.name}
          </Link>

          <nav className="navbar__links" aria-label="Primary">
            {nav.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `navbar__link ${isActive ? "navbar__link--active" : ""}`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="navbar__actions">
            <Link to="/contact" className="btn btn-primary navbar__cta">
              Get Solar Quote
            </Link>
            <button
              type="button"
              className="navbar__burger"
              aria-label="Open menu"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen(true)}
            >
              <HiOutlineMenu size={26} />
            </button>
          </div>
        </div>
      </header>

      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}
